export default function getSupportedLanguages(pageData) {
  // return the documentation language Object literal
  // and include the key as the "id" attribute

  const { documentationLanguages } = pageData;
  return Object.assign.apply(
    {},
    Object.entries(documentationLanguages).map(([key, lang]) => ({ [key]: { ...lang, id: key } })),
  );
}
